import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Card({
  image,
  body,
  buttonLabel,
  link,
  fitImage = false,
  imageHeight = "20rem",
  height = "100%",
  reverseOnBreakpoint = false,
}) {
  const [isLargeViewport, setIsLargeViewport] = useState(
    window.innerWidth >= 992
  );
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(link);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsLargeViewport(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className={`card bg-light text-start p-lg-3 d-flex flex-column ${
        reverseOnBreakpoint
          ? "d-flex flex-lg-row gap-5 align-items-center p-lg-4"
          : ""
      }`}
      style={{ width: "100%", height: height }}
    >
      {image && (
        <div
          className={fitImage ? "" : "p-3"}
          style={{
            height: imageHeight,
            ...(reverseOnBreakpoint ? { flex: 1 } : {}),
          }}
        >
          <img
            src={image}
            className={`card-img-top rounded-top ${
              fitImage ? "" : "rounded-bottom"
            }`}
            alt="..."
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
        </div>
      )}
      <div
        className="card-body gap-4 d-flex flex-column justify-content-between flex-grow-1"
        style={{
          ...(reverseOnBreakpoint ? { flex: 2 } : {}),
        }}
      >
        {body.map((item) => (
          <div key={item.title} style={{ flex: 1 }}>
            <h5 className="card-title fw-bold text-primary">{item.title}</h5>
            {item.subtitle && (
              <p
                className="card-title fw-semibold text-primary pb-2"
                style={{ fontSize: "1rem" }}
              >
                {item.subtitle}
              </p>
            )}
            <div style={{ height: "100%" }}>
              {item.description.map((descriptionItem, index) => (
                <p className="card-text" key={index}>
                  {descriptionItem}
                </p>
              ))}
            </div>
          </div>
        ))}
        {buttonLabel && (
          <button
            className="btn btn-primary ps-3 pe-3 pt-2 pb-2 rounded"
            style={{
              width: "fit-content",
            }}
            onClick={handleClick}
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
}
